import { prefixObjectValues } from '../utils';
import { asyncCreateSelect } from './inputs';
import { loadingSpinner } from './loadingSpinner';

const components = {
  loadingSpinner: prefixObjectValues(loadingSpinner, 'components'),
  asyncCreateSelect: prefixObjectValues(asyncCreateSelect, 'components'),
};
export default components;
